import {
  Col,
  Form,
  Row,
} from "react-bootstrap";

export default function AddressEditor({
  user,
  onChange,
}) {
  if (!user) return null;

  return (
    <Row className="g-3">
      <Col xs={12}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Osoite
          </Form.Label>

          <Form.Control
            value={user.osoite || ""}
            onChange={(e) =>
              onChange(
                "osoite",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>

      <Col md={4}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Postinumero
          </Form.Label>

          <Form.Control
            value={
              user.postinumero ||
              ""
            }
            onChange={(e) =>
              onChange(
                "postinumero",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>

      <Col md={8}>
        <Form.Group>
          <Form.Label className="fw-semibold">
            Toimipaikka
          </Form.Label>

          <Form.Control
            value={
              user.toimipaikka ||
              ""
            }
            onChange={(e) =>
              onChange(
                "toimipaikka",
                e.target.value
              )
            }
          />
        </Form.Group>
      </Col>
    </Row>
  );
}